/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Error
 * 
 * 1 = Warning
 * 
 * 2 = Info
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum Severity {
 Error = 0,
 Warning = 1,
 Info = 2
}

marker([
    "Enum.Severity.Error",
    "Enum.Severity.Warning",
    "Enum.Severity.Info"
]);

export namespace Severity
{
    class DataSets
    {
        static SeverityDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Error", 0, "Error"),
            new EnumValue("Warning", 1, "Warning"),
            new EnumValue("Info", 2, "Info"),
        )
    }

    export function getAsDataset() {
        return DataSets.SeverityDataSet;
    }
}
